import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy } from '@angular/core';

import { MdwDialog } from '@spaces-ui/meadow/components/dialog';

@Component({
  selector: 'app-bam-dialog',
  imports: [CommonModule, MdwDialog],
  templateUrl: './bam-dialog.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './bam-dialog.scss',
})
export class BAMDialog {}
